import type { Order } from '@haus-storefront-react/shared-types'
import { CartSummaryRow } from '../../../cart-summary/CartSummaryRow'
import type { TypographyConfig } from '../../../../types/widget-types'
import { useTranslation } from 'react-i18next'
import styles from './OrderSummary.module.scss'

interface OrderSummaryProps {
  activeOrder: Order
}

export const OrderSummary = ({ activeOrder }: OrderSummaryProps) => {
  const { t } = useTranslation()
  const totalTax = (activeOrder.taxSummary ?? []).reduce((acc, tax) => acc + tax.taxTotal, 0)

  const labelTypography: TypographyConfig = {
    variant: 'body',
    tag: 'p',
    color: 'body',
  }
  const priceTypography: TypographyConfig = {
    variant: 'body',
    tag: 'span',
    color: 'body',
  }

  return (
    <div className={styles.orderSummary}>
      <div className={styles.orderSummaryItems}>
        <CartSummaryRow
          label={t('checkout.payment.orderSummary.subtotalExcludingTax')}
          price={activeOrder.subTotal}
          priceWithTax={activeOrder.subTotalWithTax}
          type="subtotal"
          shouldBlur={false}
          currencyCode={activeOrder.currencyCode}
          labelTypography={labelTypography}
          priceTypography={priceTypography}
        />

        <CartSummaryRow
          label={t('checkout.payment.orderSummary.shipping')}
          price={activeOrder.shipping}
          priceWithTax={activeOrder.shippingWithTax}
          type="shipping"
          shouldBlur={false}
          currencyCode={activeOrder.currencyCode}
          labelTypography={labelTypography}
          priceTypography={priceTypography}
        />

        <CartSummaryRow
          label={t('checkout.payment.orderSummary.totalTax')}
          price={totalTax}
          priceWithTax={totalTax}
          type="tax"
          shouldBlur={false}
          currencyCode={activeOrder.currencyCode}
          labelTypography={labelTypography}
          priceTypography={priceTypography}
        />
      </div>

      <div className={styles.orderSummaryTotal}>
        <CartSummaryRow
          label={t('checkout.payment.orderSummary.totalAmount')}
          price={activeOrder.total}
          priceWithTax={activeOrder.totalWithTax}
          type="total"
          shouldBlur={false}
          currencyCode={activeOrder.currencyCode}
          labelTypography={{
            variant: 'lg',
            tag: 'p',
            color: 'body',
          }}
          priceTypography={{
            variant: 'xl',
            tag: 'span',
            color: 'body',
          }}
        />
      </div>
    </div>
  )
}
